import { graphql } from "src/graphql/generated";

export const currentUserQuery = graphql(/* GraphQL */ `
    query CurrentUser {
        currentUser {
            id
            email
            firstName
            lastName
        }
    }
`);
